import { Component } from '@angular/core';

@Component({
    selector: 'welcome-footer',
    templateUrl: './welcome-footer.component.html',
    standalone: false
})
export class WelcomeFooterComponent {}
